<template>
  <div class="fme-collapse-checklist">
    <div class="fme-collapse-checklist__button">
      <div class="fme-collapse-checklist__button--title">
        <slot name="title"></slot>
        <a v-if="opened === true" @click.prevent="changeOpenedStatus(false)" class="fme-collapse-checklist__button--title-button fme-montserrat-font">{{ collapseOpenedBtText }}</a>
        <a v-else @click.prevent="changeOpenedStatus(true)" class="fme-collapse-checklist__button--title-button fme-montserrat-font">{{ collapseClosedBtText }}</a>
      </div>

      <slot name="checklist"></slot>
      <slot name="tag"></slot>
    </div>

    <div class="fme-collapse-checklist__body" :class="[ opened === false ? '' : 'fme-collapse-checklist__body--display' ]">
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheCollapseChecklist',
  created () {
    this.changeOpenedStatus(this.collapseOpened)
  },
  data () {
    return {
      opened: false
    }
  },
  props: {
    collapseOpened: {
      type: Boolean,
      default: false,
      validator: function (value) {
        return [true, false].indexOf(value) !== -1
      }
    },
    collapseId: {
      type: Number,
      required: true
    },
    collapseOpenedBtText: {
      type: String,
      required: true
    },
    collapseClosedBtText: {
      type: String,
      required: true
    }
  },
  components: {
  },
  computed: {
  },
  methods: {
    changeOpenedStatus (value) {
      this.opened = value
    }
  },
  filters: {
  },
  watch: {
  }
}
</script>

<style lang="scss">
.fme-collapse-checklist {
  width: 100%;
  height: auto;
  min-height: 180px;
  background: $fme-color__write-smoke;
  border-radius: 10px;
  margin-bottom: 30px;
  .fme-collapse-checklist__button {
    position: relative;
    padding-top: 20px;
    .fme-collapse-checklist__button--title {
      .fme-collapse-checklist__button--title-text {
        display: inline;
        margin-left: 12px;
        margin-right: 12px;
        font-size: 18x;
        font-weight: 600;
        text-transform: uppercase;
        color: $fme-color__dark-silver;
      }
      .fme-collapse-checklist__button--title-button {
        display: inline;
        margin-left: 12px;
        margin-right: 12px;
        font-size: 14x;
        font-weight: 700;
        text-transform: uppercase;
        color: $fme-color__yale-blue;
        &:hover {
          cursor: pointer;
          color: $fme-color__celestial-blue;
        }
      }
    }
    .fme-collapse-checklist__more {
      margin-top: 20px;
      margin-left: 12px;
      font-size: 14x;
      font-weight: 700;
      text-transform: uppercase;
      color: $fme-color__celestial-blue;
      &:hover {
        cursor: pointer;
        color: $fme-color__yale-blue;
      }
      p {
        margin: 0;
        margin-left: 12px;
      }
    }
    .fme-collapse-checklist__tag {
      display: inline;
      position: absolute;
      background: $fme-color__pewter-blue;
      color: $fme-color__write;
      top: 20px;
      right: 12px;
      border-radius: 3px;
      padding: 3px 9px 2px 9px;
      font-size: 10px;
      font-weight: 600;
      text-transform: uppercase;
    }
  }
  .fme-collapse-checklist__body {
    display: none;
    transition: display .25s ease-in-out;
    &.fme-collapse-checklist__body--display {
      display: block;
      transition: display .25s ease-in-out;
      padding-left: 12px;
      padding-right: 12px;
      padding-bottom: 10px;
      .fme-collapse-checklist__body--items {
        .fme-collapse-checklist__body--item {
          list-style-type: none;
          padding-bottom: 40px;
          position: relative;
          &:not(:first-child) {
            margin-top: 30px;
          }
          &:first-child {
            margin-top: 25px;
          }
          &:not(:first-child) {
            padding-top: 30px;
          }
          &:not(:last-child) {
            border-bottom: 1px solid $fme-color__silver-chalice;
          }
          .fme-collapse-checklist__body--item-status {
            position: absolute;
            text-align: right;
            right: 0px;
            p {
              margin: 0;
            }
            .fme-collapse-checklist__body--item-status-icons {
              .modal-ckecklist__list-item-status--title {
                font-weight: 700;
                font-size: 12px;
                margin-right: 5px;
              }
              &.modal-ckecklist__list-item-status--accordance {
                color: $fme-color__india-green;
              }
              &.modal-ckecklist__list-item-status--not-accordance {
                color: $fme-color__rubine-red;
              }
              &.modal-ckecklist__list-item-status--not-apply {
                color: $fme-color__flame;
              }
              &.modal-ckecklist__list-item-status--to-do {
                color: $fme-color__rubine-red;
              }
              .modal-ckecklist__list-item-status--icons {
                display: inline-block;
                border-radius: 4px;
                text-align: center;
                .modal-ckecklist__list-item-status--icon {
                  font-size: 18px;
                  &.modal-ckecklist__list-item-status--icons-accordance {
                    color: $fme-color__india-green;
                  }
                  &.modal-ckecklist__list-item-status--icons-not-accordance {
                    color: $fme-color__rubine-red;
                  }
                  &.modal-ckecklist__list-item-status--icons-not-apply {
                    color: $fme-color__flame;
                    img {
                      width: 16px;
                      height: 16px;
                    }
                  }
                  &.modal-ckecklist__list-item-status--icons-to-do {
                    color: $fme-color__rubine-red;
                    sup {
                      color: $fme-color__rubine-red;
                      -webkit-touch-callout: none;
                        -webkit-user-select: none;
                        -khtml-user-select: none;
                          -moz-user-select: none;
                            -ms-user-select: none;
                                user-select: none;
                    }
                  }
                  &.svg-inline--fa {
                    &.modal-ckecklist__list-item-status--icons-accordance {
                      color: $fme-color__india-green;
                    }
                    &.modal-ckecklist__list-item-status--icons-not-accordance {
                      color: $fme-color__rubine-red;
                    }
                    &.modal-ckecklist__list-item-status--icons-not-apply {
                      color: $fme-color__flame;
                    }
                    &.modal-ckecklist__list-item-status--icons-to-do {
                      color: $fme-color__rubine-red;
                      sup {
                        color: $fme-color__rubine-red;
                        -webkit-touch-callout: none;
                          -webkit-user-select: none;
                          -khtml-user-select: none;
                            -moz-user-select: none;
                              -ms-user-select: none;
                                  user-select: none;
                      }
                    }
                    vertical-align: -2px;
                  }
                }
              }
            }
            .fme-collapse-checklist__body--item-status-name {
              font-size: 14px;
              font-weight: 700;
              color: $fme-color__dark-silver;
            }
            .fme-collapse-checklist__body--item-status-datetime {
              font-size: 10px;
              font-weight: 400;
              color: $fme-color__dark-silver;
            }
          }
          .fme-collapse-checklist__body--item-title {
            font-size: 14px;
            font-weight: 700;
            color: $fme-color__dark-silver;
          }
          .fme-collapse-checklist__body--item-comment {
            font-size: 14px;
            font-weight: 400;
            color: $fme-color__dark-silver;
          }
          .fme-collapse-checklist__body--item-title-media {
            font-size: 17px;
            font-weight: 700;
            color: $fme-color__dark-silver;
            margin: 0;
            margin-top: 35px;
            margin-bottom: 20px;
          }
          .fme-collapse-checklist__body--item-images {
            margin-bottom: 15px;
            .fme-collapse-checklist__body--item-image {
              display: inline-block;
              margin-right: 15px;
              a {
                &:hover {
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
